import anime from 'animejs';

const pageHeader = (settings) => ({
    enableAnimation: false,
    index: null,
    delay: null,
    id: null,
    ...settings,

    init() {
        this.initAnimation()
    },
    initAnimation(){
        if (this.enableAnimation){
            const ANIMATION_DELAY = this.delay;
            const LETTER_DELAY = 50;
            const ANIMATION_DURATION = 2500;
            const CLASS_SPEEDY_ANIMATION_DURATION = ANIMATION_DURATION - 700;

            var textWrapper = this.$el.querySelector('.animated-text-js');
            if (!textWrapper) return;

            textWrapper.style.opacity = 1;
            anime.timeline({
                loop: false
            })
            .add({
                targets: (`#${this.id} .animated-text-js`),
                translateY: [50, 0],
                opacity: [0, 1],
                easing: "easeOutExpo",
                duration: ANIMATION_DURATION,
                delay: (el, i) => ANIMATION_DELAY + LETTER_DELAY * i
            });

            setTimeout(() => {
                this.$el.classList.add('animation-completed');
            }, CLASS_SPEEDY_ANIMATION_DURATION);
        }
    }
})

export default pageHeader

document.addEventListener("alpine:init", () => {
    Alpine.data("pageHeader", pageHeader);
})
